/**
 * Who sees native Cinch AI (the bubble, the nav item, the page) in the working company.
 * - `flagOn`: the LaunchDarkly release gate `cinch-ai-app` (everyone, internal users included).
 * - `installed`: the Cinch AI app on the company (`hasIntegration('cinch_ai')`).
 * - `access`: `/ai/app/access` ({installed, allowed, internal}), null while loading.
 * Internal users (superusers and @cinch.io; Justin, 2026-10-30) see it on any company they can access,
 * installed or not. Everyone else needs the app installed and to be on its allow-list (CINCHAI-122).
 */

/** The LaunchDarkly release flag (`flags[CINCH_AI_FLAG]`) and the Cinch AI app's integration key. */
export const CINCH_AI_FLAG = 'cinch-ai-app';
export const CINCH_AI_INTEGRATION = 'cinch_ai';

/**
 * The rollout flag, the switch between the two Cinch AIs (dark on merge; Chris's review of FE #2325).
 * Off: nothing native shows or calls `/ai/*`, and the legacy entries behave exactly as on develop.
 * On: native Cinch AI replaces them. Product decision: with the flag on, the legacy link and the socket
 * widget are gone for that user even if they aren't on the native allow-list.
 */
export const cinchAiAppOn = flags => !!flags?.[CINCH_AI_FLAG];

/** Flag off: the legacy sidebar link to the Open WebUI fork, on develop's flag `cinch_ai`. */
export const legacyAiLinkShown = flags => !cinchAiAppOn(flags) && !!flags?.cinch_ai;

/** Flag off: the legacy agents-backend socket widget (AgentInterface) and its cog toggle, on develop's flag `ai_chat_bot`. */
export const legacyAiWidgetShown = flags => !cinchAiAppOn(flags) && !!flags?.ai_chat_bot;
export function aiVisible(flagOn, installed, access) {
  return !!flagOn && !!access?.allowed && (!!access.internal || !!installed);
}

/** Why the page isn't shown, for CinchAiUnavailable: 'flag' | 'app' | 'allow', or null when it is. */
export function aiUnavailableReason(flagOn, installed, access) {
  if (!flagOn) return 'flag';
  if (!access?.internal && !installed) return 'app';
  if (!access?.allowed) return 'allow';
  return null;
}